module.exports = __webpack_public_path__ + "img/edoras-3018-09-23.3071c357.jpg";